module.exports = __webpack_public_path__ + "img/bgTitle3.fd5c34ec.png";